/**
 * Nomenclature: STR_<PageName>_<Message>
 * e.g. to show that no modifiers are present in the summary page,
 * STR_SUMMARY_PAGE_NO_MODIFIERS = "No modifiers were set for this campaign"
 *
 * For strings that can be used across pages, the page_name can be skipped
 */

export const STR_SUMMARY_PAGE_NO_MODIFIERS = "No modifiers were set for this campaign"
export const STR_SUMMARY_PAGE_NO_FILTERS = "No targeting was set for this campaign"
export const STR_SUMMARY_PAGE_NO_SCHEDULE = "No schedule was set for this campaign"
export const STR_SUMMARY_PAGE_NO_TERRITORY = "No territory was set for this campaign"

export const STR_CAMPAIGN_FILTERS_MULTIPLE_FILTERS_WARNING = "Multiple filter groups are not supported on your account. Please remove the existing filters to add a new one."
// For AllCreative.js
export const CREATIVE_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Creative",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this creative?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

export const CREATIVE_NOTICE_STR = {
    DELETE_TEXT_HEADING: "Notice",
    DELETE_TEXT_MESSAGE:
        "This creative can not be deleted because it is being used by one or more campaigns.",
    DELETE_TEXT_CTA: "OK",
}

// For Pixel

export const PIXEL_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Pixel",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this pixel?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

export const TOPIC_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Metric",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this metric?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

export const NOTE_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Note",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this note?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

// For Api Token
export const API_TOKEN_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete API Token",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this API Token?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

// For Zip Tier
export const ZIP_TIER_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Zip Tier",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this Zip Tier?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

// For Billings.js
export const CARD_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Card",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this card?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

// For LeadDriver.js
export const DRIVER_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Driver",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this driver?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

// For LeadApplicant.js
export const APPLICANT_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Applicant",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this applicant?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

// For LeadHome.js
export const HOME_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Home",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this home?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

// For LeadCoverage.js
export const COVERAGE_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Coverage",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this coverage?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

// For LeadClaims.js
export const CLAIMS_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Claim",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this claim?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

// For LeadViolations.js
export const VIOLATIONS_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Violation",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this Violation?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

// For LeadVehicles.js
export const VEHICLES_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Vehicle",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this Vehicle?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

// For Business Entity
export const BUSINESS_ENTITY_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Business Entity",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this Business Entity?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

export const CARD_FUND_STR = {
    CONFIRM_TEXT_HEADING: "Add Fund",
    CONFIRM_TEXT_MESSAGE: "Are you sure you want to add fund to this account?",
    CONFIMR_BTN_TEXT: "Confirm",
}

export const USER_INVITE_STR = {
    RESEND_SUCCESS_MSG: 'Invite sent successfully.',
    RESEND_FAILURE_MSG: 'Failed to send invite.',
    RESEND_ERROR_TYPE: 'resend_failure'
}

// For Conversion Log
export const CONVERSION_LOG_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Conversion Upload",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this Conversion Upload?",
    DELETE_TEXT_CTA: "Yes, delete it",
    DELETE_TEXT_CTA_DISABLED: "This Conversion Upload is still in progress. Please wait until the upload is complete before attempting to delete it.",
}

//MONTH NAMES
export const MONTH_NAMES = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
]

//ERROR STRINGS

export const RESET_PWD_ERROR_PREVIOUS_PASSWORD = "password was used previously."
export const ERROR_MIN_NUM_HOURS_RETAIL = "Minimum number of hours is 25. Please update your schedule accordingly"

export const USER_NOTIFICATION_DELETE_STR = {
    DELETE_TEXT_HEADING: "Delete Notification",
    DELETE_TEXT_MESSAGE: "Are you sure you want to delete this Notification?",
    DELETE_TEXT_CTA: "Yes, delete it",
}

export const ACCOUNTING_TAB_FEEDBACK_ROLLBACK_STR = {
    DELETE_TEXT_HEADING: "Rollback Event",
    DELETE_TEXT_MESSAGE: "Are you sure you want to rollback this event?",
    DELETE_TEXT_CTA: "Yes, rollback it",
}

export const SF_INVOICE_CONSTANTS = {
    CREATED_AT: "created_at",
    UPDATED_AT: "updated_at",
    AMOUNT: "amount",
    CARRY_OVER: "carry_over",
    OUTSTANDING_BALANCE: "outstanding_balance",
    PAID_AMOUNT: "paid_amount",
    FROM_DATE: "from_date",
    TO_DATE: "to_date",
    DUE_DATE: "due_date",
    DATE_PAID: "date_paid",
    DATE_PAID: "date_paid",
    GENERATED: "generated",
}

export const ORDER_BY = {
    DESC: "desc",
    ASC: "asc"
} 

export const NAME_OF_CURRENT_ACCOUNT_COLUMN = {
    INTERNAL: "internal",
    CALL_DETAILS_ENABLED: "call_details_enabled",
    ENTERPRISE: "enterprise"
}

export const LATEST = 'latest';

export const PLATFORM_SETTINGS_FEATURES = {
    IS_CLICKS_PRODUCT_ENABLED: 'isClicksProductEnabled',
    IS_SOURCE_SETTINGS_ENABLED: 'isSourceSettingsEnabled',
    IS_PIXEL_CONVERSION_SETTINGS_ENABLED: 'isPixelConversionSettingsEnabled',
    IS_PROFILES_ENABLED: 'isProfilesEnabled',
    IS_METRICS_ENABLED: 'isMetricsEnabled',
    IS_TARGETING_PACKAGES_ENABLED: 'isTargetingPackagesEnabled'
}
export const DEFAULT_FILTERD_URL_PARAMS = encodeURIComponent('{"page_number":1,"filters":null}');
